import { render, staticRenderFns } from "./adverts-list-pagination.vue?vue&type=template&id=5eb9227c"
import script from "./adverts-list-pagination.vue?vue&type=script&lang=ts"
export * from "./adverts-list-pagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports